import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { MainDiv } from '../component/main/MainDiv';
import { MainNavigationBar } from '../component/navigation-bar/MainNavigationBar';

export const MainPage = () => (
  <MainPageLayout
    navigationBar={<MainNavigationBar />}
    elementCentr={<MainDiv />}
  />
);
